// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const ViewsPerSessionTouch: React.FC = () => {
  const {
    data: { viewsPerSessionTouch },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, viewsPerSessionTouch, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="blue"
        title="Touchscreen Views per Session"
        subtitle="Amount open views per session. One session can be converted to one user."
        label="Views"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
